import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { DeviceTrackingService } from 'app/core/device/device-tracking.service';

/**
 * Adds `x-device-id`, `x-device-type` and `x-browser` to every request for the admin API, signed
 * in or not, so the backend's request log knows which browser sent it (see DeviceTrackingService).
 *
 * Independent of AccessTokenInterceptor: it neither reads nor changes the token, and never looks
 * at a response.
 */
@Injectable()
export class DeviceInfoInterceptor implements HttpInterceptor {
    constructor(private readonly deviceTracking: DeviceTrackingService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(this.withDeviceHeaders(request));
    }

    /**
     * Only `API_BASE_URL` gets the headers. Every other host is left alone: `FILE_UPLOAD_URL`,
     * RPC nodes, and the Fuse mock API's `api/common/*` requests.
     * Any error here sends the request exactly as it was: the log is never worth a failed call.
     */
    private withDeviceHeaders(request: HttpRequest<unknown>): HttpRequest<unknown> {
        try {
            if (!environment.DEVICE_TRACKING_ENABLED || !request.url.startsWith(environment.API_BASE_URL)) {
                return request;
            }
            const headers = this.deviceTracking.getHeaders();
            return Object.keys(headers).length ? request.clone({ setHeaders: headers }) : request;
        } catch (error) {
            console.error('Device headers skipped:', error);
            return request;
        }
    }
}
